import styled from 'styled-components'
import { Form } from '@/components/CoForm'

export const StyledForm = styled(Form)`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 1rem;
`
